<template>
  <div class="official-acc-auth">
    <pageTitle :pageTitle="$t('lang.k_319001')">
      <span class="title_tips">{{ $t('lang.k_319029') }}</span>
    </pageTitle>

    <vh-tabs class="official-acc-tabs" v-model="activeTab">
      <vh-tab-pane name="1">
        <span slot="label">
          {{ $t('lang.k_319030') }}
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              <p>{{ $t('lang.k_319002') }}</p>
              <p>{{ $t('lang.k_319003') }}</p>
              <p>{{ $t('lang.k_319004') }}</p>
              <p>{{ $t('lang.k_319005') }}</p>
              <p>{{ $t('lang.k_319006') }}</p>
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
        </span>
        <OfficialHosted />
      </vh-tab-pane>
      <vh-tab-pane :label="$t('lang.k_319031')" name="2">
        <OfficialSecret />
      </vh-tab-pane>
    </vh-tabs>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import OfficialHosted from './components/OfficialHosted.vue';
  import OfficialSecret from './components/OfficialSecret.vue';
  export default {
    name: 'OfficialAccAuth',
    components: {
      PageTitle,
      OfficialHosted,
      OfficialSecret
    },
    data() {
      return {
        activeTab: '1'
      };
    }
  };
</script>

<style lang="less" scoped>
  .official-acc-auth {
    .title_tips {
      font-size: 14px;
      color: #999;
      margin-left: 10px;
    }
    .official-acc-tabs {
      background-color: #fff;
    }
  }
</style>
